import React from 'react';
import { Button, Col } from 'react-bootstrap';
import renderUtils from '../../../helpers/renderUtils';
import CustomCard from '../../../components/CustomCard';
import DivCenter from '../../../components/div/DivCenter';
import DatesRange from '../../../components/lakeview/DatesRange';
import PaymentSummary from '../../reservation/checkout/PaymentSummary';
import { useOffer } from '../../../context/OfferProvider';
import Price from '../../../components/lakeview/Price';
import ShortGuestsSummary from '../../../components/lakeview/ShortGuestsSummary';

const OfferSummary = ({
  offer,
  width,
  onClickNext,
  nextLabel,
  title,
  toggle,
  readOnly = false,
  show = true,
  reservation,
}) => {
  if (!offer || !show) {
    return <></>;
  }

  const {
    manualDiscounts,
    setManualDiscounts,
    manualAdditionalPayments,
    setManualAdditionalPayments,
  } = useOffer();

  const {
    paymentSummary,
    nights,
    guests,
    startDate,
    endDate,
    house,
    available,
  } = offer;

  const pricePerNight =
    paymentSummary?.total && nights
      ? (paymentSummary.total / nights).toFixed(2)
      : null;

  function removeDiscount(d) {
    const updated = manualDiscounts.filter((md) => md.uuid !== d.uuid);
    setManualDiscounts(updated);
  }

  function removeAdditionalPayment(ap) {
    const updated = manualAdditionalPayments.filter(
      (map) => map.uuid !== ap.uuid,
    );
    setManualAdditionalPayments(updated);
  }

  return (
    <>
      <Col md={width}>
        <div style={{ position: 'sticky', top: '170px', zIndex: 10 }}>
          <CustomCard withoutHeader={!title} title={title} width={12}>
            {/* Pokazujemy ceny tylko jeśli istnieje paymentSummary */}
            {paymentSummary && paymentSummary.total && (
              <div className="d-flex justify-content-between align-items-center mb-3">
                <div>
                  <span className="h6 fw-bold">
                    <Price value={pricePerNight} />
                  </span>
                  <span className="text-muted"> /noc</span>
                </div>
                <div>
                  <span className="h4 fw-bold">
                    <Price value={paymentSummary.total} />
                  </span>
                  <span className="text-muted">
                    {' '}
                    / {nights} {renderUtils.getNightLabel(nights)}
                  </span>
                </div>
              </div>
            )}

            {/* Daty i goście pokazujemy zawsze */}
            <CustomCard withoutHeader={true} shadow={false} className="mb-3">
              <DatesRange startDate={startDate} endDate={endDate} />
              <div>
                <br />
                <strong>
                  <ShortGuestsSummary guests={guests} label={true} />
                </strong>
                <small className="text-muted">Goście</small>
              </div>
            </CustomCard>

            {/* Jeśli brak paymentSummary */}
            {!available && !reservation && (
              <DivCenter className="py-3">
                <div className="text-center text-muted">
                  <h6>
                    Domek niedostępny dla rezerwacji przy podanych parametrach
                  </h6>

                  {offer.unavailableReasons?.length > 0 && (
                    <div className="d-flex flex-column align-items-center text-danger mb-2 mt-3">
                      {offer.unavailableReasons.map((reason, index) => (
                        <small key={index}>{reason}</small>
                      ))}
                    </div>
                  )}

                  <small className={'mt-3'}>
                    Spróbuj zmienić daty lub liczbę gości
                  </small>
                </div>
              </DivCenter>
            )}

            {(available || reservation) && (
              <PaymentSummary
                paymentSummary={paymentSummary}
                nights={nights}
                removeDiscount={removeDiscount}
                removeAdditionalPayment={removeAdditionalPayment}
                readOnly={readOnly}
              />
            )}

            {/* Przycisk dalej */}
            {available && !readOnly && (
              <Button
                variant="primary"
                onClick={onClickNext}
                disabled={!onClickNext}
                className="w-100 mt-3"
              >
                {nextLabel || 'Rezerwuj'}
              </Button>
            )}
          </CustomCard>
        </div>
      </Col>
    </>
  );
};

export default OfferSummary;
